module.exports = __webpack_public_path__ + "img/kalamba.02dccfdb.svg";